import { formatProjectNumber } from '../../components/primitives';
import type { NumberedTrashProject } from './types';

function numberedTrashDateLabel(ms: number): string {
  const d = new Date(ms);
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `trashed ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear() !== new Date().getFullYear() ? d.getFullYear() : ''}`.trim();
}

/** Strikethrough history row — shared by Projects index and client detail. */
export function NumberedTrashProjectRow({ p }: { p: NumberedTrashProject }) {
  return (
    <div className="row numbered-trash">
      <span className="num">{p.project_number !== null ? formatProjectNumber(p.project_number) : '—'}</span>
      <span className="row-title" title={p.name}>{p.name}</span>
      {p.client_name && <span className="row-context" title={p.client_name}>{p.client_name}</span>}
      <span className="row-spacer" />
      <span className="row-meta dim col-due">{numberedTrashDateLabel(p.deleted_at)}</span>
    </div>
  );
}
